'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumber = exports.inRange = void 0;
/**
 *
 * @param {number} from - Lower limit
 * @param {number} to - Upper limit
 * @param {number} value - Checked number value
 *
 * @return {number} Either source value itself or limit value if range limits
 *   are exceeded
 */
var inRange = function (from, to, value) {
    if (value < from) {
        return from;
    }
    if (value > to) {
        return to;
    }
    return value;
};
exports.inRange = inRange;
/**
 *  Function used to format numbers for session summary manager modal
 */
var formatNumber = function (amount) {
    if (amount === null) {
        return '0.00';
    }
    var amountString = "" + amount;
    if (amountString.includes('.')) {
        var secondDecimal = amountString.indexOf('.') + 3;
        amountString = amountString.substring(0, secondDecimal);
    }
    return amountString;
};
exports.formatNumber = formatNumber;
